import { Injectable, signal } from "@angular/core";
import { PreferenceService } from "../../services/preference.service";

export interface ActionResponse {
    actionType: ActionType;
    payload?: string;
}

export type ActionType = "searchQuery" | "pricingFormula";

@Injectable({ providedIn: "root" })
export class AiStore {
    private isLoadingSignal = signal<boolean>(true);
    readonly isLoading = this.isLoadingSignal.asReadonly();

    private customNameSignal = signal<string | null>(null);
    readonly customName = this.customNameSignal.asReadonly();

    private hasAiEnabledSignal = signal<boolean | null>(null);
    readonly hasAiEnabled = this.hasAiEnabledSignal.asReadonly();

    private allActionsSignal = signal<ActionResponse[]>([]);
    readonly allActions = this.allActionsSignal.asReadonly();

    private lastActionSignal = signal<ActionResponse>(null);
    readonly lastAction = this.lastActionSignal.asReadonly();

    constructor() {
        this.init();
    }

    async init() {
        const prefs = await PreferenceService.getPreferences(["config_chatbot_name", "HasAiFeatures"]);

        this.hasAiEnabledSignal.update(() => prefs.HasAiFeatures.value == "T");
        this.customNameSignal.update(() => prefs.config_chatbot_name.value);
        this.isLoadingSignal.update(() => false);
    }

    pushAction(newAction: ActionResponse) {
        this.allActionsSignal.update((arr) => [...arr, newAction]);
        this.lastActionSignal.set(newAction);
    }
}
